module.exports = __webpack_public_path__ + "img/soil_temp.8dab18fc.png";